let Config = {};

/*LOCAL
//Config.REST_URL_AD_AUTH = 'http://apiint.houstonisd.org/common/api/userinfo';
Config.REST_URL= 'http://localhost:54751/';  //USING HISDCustomDevAppsWebAPI.csproj
Config.REST_URL_USER = 'http://apiint.houstonisd.org/';
*/

/*INTEGERATION
Config.REST_URL_AD_AUTH = 'http://apiint.houstonisd.org/common/api/userinfo';
Config.REST_URL = "http://apiint.houstonisd.org/AskITService/";
Config.REST_URL_USER = 'http://apiint.houstonisd.org/';
*/


/*PRODUCTION
Config.REST_URL = "https://api.houstonisd.org/AskITService/";
Config.REST_URL_AD_AUTH = 'https://api.houstonisd.org/common/api/userinfo';
Config.REST_URL_USER = 'https://api.houstonisd.org/';
*/

/*AZURE -DEV
Config.REST_URL_AD_AUTH = '';
Config.REST_URL = "https://api-askit-dev.azurewebsites.net/";
Config.REST_URL_USER = '';
*/


/*AZURE -PRODUCTION*/
Config.REST_URL_AD_AUTH = '';
Config.REST_URL = "https://api-askit-prod.azurewebsites.net/";
Config.REST_URL_USER = '';






export default Config;